import React, { useState } from "react";
import axiosInstance from "../../helpers/axiosInstance"; 
import "../login/login.css";
import emailIcon from "../../images/mail.png";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email) {
            Swal.fire("Error", "Please enter your email!", "error");
            return;
        }
    
        if (!isValidEmail(email)) {
            Swal.fire("Error", "Please enter a valid email address!", "error");
            return;
        }
    
        try {
            setLoading(true);
    
            const response = await axiosInstance.post("/api/auth/forgot-password", { email });
    
            Swal.fire({
                title: "Success!",
                text: response.data?.message || "Password reset email sent successfully!",
                icon: "success",
                confirmButtonText: "OK",
                confirmButtonColor: "#2d3394"
            });
    
        } catch (err) {
            setError(err.response?.data?.message || "Login failed. Please try again.");
            console.log(err);
        } finally {
            setEmail("");
            setLoading(false);
        }
    };
    

    return (
        <div className="login-container d-flex justify-content-center align-items-center vh-100">
            <div className="login-box p-3 shadow-lg">
                <h2 className="login-title text-center mb-4 mt-3">Forgot Password</h2>
                <p className="login-subheading text-start">
                    Please provide your email address to receive a password reset link.
                </p>
                {error && <p className="text-danger text-center">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="email-group position-relative mt-4 mb-5">
                        <label className="email-label position-absolute px-2">Email</label>
                        <div className="email-input-container position-relative p-2 d-flex align-items-center">
                            <img src={emailIcon} alt="Email Icon" className="email-icon mt-3" />
                            <input
                                type="email"
                                className="email-input form-control pl-5"
                                placeholder="email@gmail.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div className=" my-4 d-grid login-button-container">
                    <button type="submit" className="login-btn w-100" disabled={loading}>
                            {loading ? "Sending..." : "Send Reset Link"}
                        </button>
                    </div>

                    <div className=" text-center login-link">
                        <NavLink to="/login" className="Goto-link">Go to Login Page</NavLink>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
